import { render } from "./CardsDashboardMonth.vue?vue&type=template&id=0cd35e86&ts=true"
import script from "./CardsDashboardMonth.vue?vue&type=script&lang=ts"
export * from "./CardsDashboardMonth.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__